import React, { useEffect, useState } from "react";
import { Button } from "antd";

import { getPrinters, reprintItemLabel } from "../../utils/Print";
import { Order, Item } from "../../../types/model";

interface ReprintItemLabelButtonProps {
  className?: string;
  style?: React.CSSProperties;
  size?: "small" | "middle" | "large";
  handleError: (err: Error) => void;
  children: React.ReactNode;
  order: Order;
  item: Item;
}

const ReprintItemLabelButton: React.FC<ReprintItemLabelButtonProps> = ({
  className,
  style,
  size,
  handleError,
  children,
  order,
  item,
}) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  // Test to see if we can reach the print agent.
  useEffect(() => {
    getPrinters((_: any, err?: Error) => {
      if (err) {
        // Do nothing, do not enable the button.
      } else {
        setDisabled(false);
      }
    });
  }, [order]);

  return (
    <Button
      type="primary"
      disabled={disabled}
      loading={loading}
      className={className}
      style={style}
      size="large"
      onClick={() => {
        setLoading(true);
        reprintItemLabel(
          order,
          item,
          () => {
            setLoading(false);
          },
          (err) => {
            setLoading(false);
            handleError(err);
          }
        );
      }}
    >
      {children}
    </Button>
  );
};

export default ReprintItemLabelButton;
